import IconButton from "@mui/material/IconButton";
import Tooltip from '@mui/material/Tooltip';
import React, {useState} from "react";
import TextField from "@material-ui/core/TextField";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import PropTypes from "prop-types";
import "../../../editorStyleSheet.css";
import {useSoftUIController} from "../../../../../context";
import { useSearchParams } from "react-router-dom";
import {
    ChevronLeft,
    ChevronRight,
    SkipBack,
    SkipForward,
} from "lucide-react";
import {Box, Typography} from "@mui/material";

const PageNavigation = ({pageNumber, numPages, setForcePageNumber, t}) => {


    const [anchorEl, setAnchorEl] = useState(null);
    const [newPageNumber, setNewPageNumber] = useState('');
    const [controller, dispatch] = useSoftUIController();
    const {closedForcePageNumber} = controller;
    const [searchParams, setSearchParams] = useSearchParams();
    const isFirstPage = pageNumber === 1;
    const isLastPage = pageNumber === numPages;
    const firstPageClass = isFirstPage ? 'disabled' : 'clickable';
    const lastPageClass = isLastPage ? 'disabled' : 'clickable';

    const goToFirstPage = () => {
        if (!isFirstPage) updatePageNumber(1);
    };
    const goToPreviousPage = () => {
        if (!isFirstPage) updatePageNumber(pageNumber - 1);
    };
    const goToNextPage = () => {
        if (!isLastPage) updatePageNumber(pageNumber + 1);
    };
    const goToLastPage = () => {
        if (!isLastPage) updatePageNumber(numPages);
    };

    const updatePageNumber = (pageNumber) => {
        setForcePageNumber(pageNumber);
        searchParams.set("page", pageNumber);
        setSearchParams(searchParams);
    };

    const handleClick = (event) => {
        setNewPageNumber(pageNumber)
        setAnchorEl(event.currentTarget);
        setForcePageNumber(pageNumber);
    };

    const handleClose = () => {
        setAnchorEl(null);

    };


    return(
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            backgroundColor: 'rgb(75 78 83 / 70%)',
            borderRadius: 2,
            paddingLeft: "8px",
            paddingRight: "8px",
            paddingTop: "4px",
            paddingBottom: "4px"
        }}
        >
            <Tooltip title={t('go_to_first_page')}>
                <IconButton
                    className={`${firstPageClass}`}
                    onClick={goToFirstPage} id="basic-button"
                >
                    <SkipBack size={16} />
                </IconButton>
            </Tooltip>
            <Tooltip title={t('go_to_previous_page')}>
                <IconButton
                    className={`${firstPageClass}`}
                    onClick={goToPreviousPage} id="basic-button"
                >
                    <ChevronLeft size={16} />
                </IconButton>
            </Tooltip>
            <Typography variant="body2" sx={{ color: "white" }}>
                {t('page')}{' '}
            </Typography>
                <Button
                    style={{ color: 'white'}}
                    onClick={handleClick}
                >
                    {pageNumber}
                  </Button>
            <Typography variant="body2" sx={{ color: "#9CA3AF" }}>
                {t('of')}{' '}
            </Typography>
            <Typography  variant="body2" sx={{ color: "#9CA3AF" }}>
                {numPages}
            </Typography>

            <Menu
                className="zoom-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl) }
                onClose={handleClose}
                container={document.fullscreenElement || undefined}
                PaperProps={{
                    sx: {
                        backgroundColor: '#ffffff',
                    }
                }}
            >
                <MenuItem>
                    <TextField
                        className="num-pages"
                        type={"text"}
                        size="small"
                        defaultValue={pageNumber}
                        value={newPageNumber}
                        inputProps={{ min: 1, max: 3 }}
                        style={{
                            width: 48,
                            "& .MuiInputBaseInput": {
                                color: "white",
                                textAlign: "center",
                                fontSize: "0.875rem",
                                padding: "4px 8px",
                            },
                            "& .MuiOutlinedInputRoot": {
                                height: 32,
                                background: "#fff !important",
                                "& fieldset": {
                                    borderColor: "#fff",
                                },
                            },
                        }}
                        min={1}
                        max={numPages || 1}
                        onChange={(event) => setNewPageNumber(event.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                updatePageNumber(Number(newPageNumber));
                            }
                        }}
                    />

                </MenuItem>
            </Menu>
            <Tooltip title={t('go_to_next_page')}>
                <IconButton
                    className={`${lastPageClass}`}
                    onClick={goToNextPage} id="basic-button"
                >
                    <ChevronRight size={16} />
                </IconButton>
            </Tooltip>
            <Tooltip title={t('go_to_last_page')}>
                <IconButton
                    className={`${lastPageClass}`}
                    onClick={goToLastPage} id="basic-button"
                >
                    <SkipForward size={16} />
                </IconButton>
            </Tooltip>
        </Box>
    );

}

PageNavigation.propTypes = {
    numPages: PropTypes.number,
    pageNumber: PropTypes.number,
    setForcePageNumber: PropTypes.func,
    t: PropTypes.func,
};


export default PageNavigation;